import React from "react";
import AdminProfileAdd from "./adminProfile";
import SupplierProfileAdd from "./supplierProfile";
import GDProfileAdd from "./gdProfile";

const ProfileAdd = () => {
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = userData?.user_type;
  const subAdminId = userData?.sub_admin_id;

  return (
    <>
      {userType === "admin" ? (
        <AdminProfileAdd />
      ) : userType === "supplier" ? (
        <SupplierProfileAdd />
      ) : userType === "subadmin" && subAdminId === 1 ? (
        <GDProfileAdd />
      ) : (
        <AdminProfileAdd />
      )}
    </>
  );
};

export default ProfileAdd;
